import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './FullPageError.css';
import Button from '../Button';

export const FullPageError = ({ error, hide }) => (<div
    className={styles.container}
>
    <h1>Oops!</h1>
    {error ?
        <p className={styles.message}>{error}</p> :
        <p>Something went wrong! Sorry about that.</p>}
    {!hide && (<Link to="/">
        <Button>Go Home</Button>
    </Link>)}
</div>);

FullPageError.propTypes = {
    error: PropTypes.any,
    hide: PropTypes.bool,
};

export default FullPageError;



// WEBPACK FOOTER //
// ./src/client/Components/FullPageError/FullPageError.js